<template>
    <button class="btn-challenge-results-main-action">
        <span class="btn-challenge-results-main-action__text">TAMAM</span>
    </button>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {};
</script>

<style scoped src="@/css/components/btn-challenge-results-main-action.css"></style>